import { jsPDF } from "jspdf";
import { Box } from "../layout/box.ts";
import { BaseElement } from "./baseElement";

export class Empty extends BaseElement {
	constructor() {
		super(new Box(), "empty");
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	async calculate(_: jsPDF): Promise<void> {
		//Do nothing
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	async draw(_: jsPDF): Promise<void> {
		//Do nothing
	}
}
